type Props = {
  readonly visible: boolean;
};

/**
 * Fixed footer that hides on scroll-down (same behavior as header) to maximize reading space.
 */
export default function SiteFooter({ visible }: Props) {
  return (
    <footer
      className={[
        "fixed bottom-0 left-0 right-0 z-40 border-t border-border/60 bg-surface/75 py-3 text-center text-sm text-muted backdrop-blur-xl transition-transform duration-300 ease-out",
        visible ? "translate-y-0" : "translate-y-full",
      ].join(" ")}
    >
      <p className="text-muted">© {new Date().getFullYear()} CodeWithCK</p>
    </footer>
  );
}
